const market = {
    dsbz: 'Koin yang Akan Ditambahkan',
    kpsj: 'Hitungan Mundur Buka/Waktu Buka',
    ykp: 'Telah Dibuka',
    kpdjs: 'Hitungan Mundur Buka',
    worning: 'Bukan harga perdagangan akhir, hanya untuk referensi',
    swapTab_1: 'Kontrak USDT-M',
    swapTab_2: 'Kontrak Coin-M',
    searchCoin: 'Cari koin yang diinginkan',
    risk: 'Peringatan Risiko',
    addSelfCode: 'Tambahkan ke Favorit',
    pair: 'Pasangan',
    latestPrice: 'Harga Terkini',
    changeHour: 'Perubahan %',
    highHour: 'Tertinggi 24H',
    lowHour: 'Terendah 24H',
    priceTrend: 'Tren Harga (3 Hari)',
    volumeHour: 'Volume 24H',
    noSearch: 'Belum ada hasil pencarian koin',
    noAdd: 'Belum menambahkan favorit',
    noYet: 'Koin ini belum terdaftar',
    noBi: 'Koin belum tersedia',
    wan: 'Ribu',
    qian: 'Ribu',
    yi: 'Juta',
    yxhy: 'Kontrak Perpetual',
    wghy: 'Kontrak Grid',
    cxjy:
        'Koin di Zona Inovasi umumnya memiliki pencapaian tertentu dalam teknologi dan pasar, tetapi harganya sangat fluktuatif dan risikonya relatif tinggi. Disarankan untuk memeriksa informasi terkait dengan cermat dan memutuskan partisipasi dalam batas yang dapat ditanggung.',
    qljy:
        'Zona Trading Potensial masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.',
    qljyDao: 'Zona Trading DAO masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.',
    default: 'Zona trading masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.',
    storage: 'Zona Trading Penyimpanan masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.',
    dlt:
        'Aset digital di Zona Likuiditas Rendah memiliki likuiditas pasar yang rendah dan berisiko dihapus dari pencatatan. Disarankan untuk mempertimbangkan dengan hati-hati sebelum berinvestasi.',
    defi:
        'Zona Trading DEFI masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.',
    nft: "Zona Trading NFT masih dalam tahap awal pengembangan pasar. BiKing tidak dapat menjamin konsensus nilai dan kondisi likuiditas pasarnya. Harap tinjau informasi proyek dengan cermat dan berinvestasi dengan hati-hati dalam batas yang dapat Anda tanggung.",

    hz: "Perpetual",
    yx: "Pilihan Riset",
    yjyzx: "Proyek Pilihan Institut Riset",
    zx: 'Favorit',
    bb: 'Spot',
    hy: 'Kontrak',
    zfb: 'Peringkat Kenaikan',
    xbb: 'Peringkat Koin Baru',
    bd: 'Pasangan',
    zxj: 'Harga Terkini',
    zdf24: 'Perubahan 24H',
    high24: 'Tertinggi 24H',
    low24: 'Terendah 24H',
    turnover24: 'Volume 24H',
    zd24: 'Perubahan 24h',
    zjrzd: 'Harga/Perubahan Harian',
    scgl: 'Ikhtisar Pasar',
    jysj: 'Data Trading',
    fyje: "Jumlah Komisi",
    ms: "Ya",
    mf: "Tidak",
    是否交易: 'Apakah Trading',
    推荐好友: 'Rekomendasikan Teman',
    推荐: "Rekomendasi",
    合约交易返佣: 'Dapatkan komisi trading kontrak yang tinggi',
    我的返佣比例: 'Rasio Komisi Saya',
    好友返佣比例: 'Rasio Komisi Teman',
    推荐码: 'Kode Referal',
    交易人数: 'Jumlah Trader',
    推荐总览: 'Ikhtisar Referal',
    推荐人数: 'Jumlah Orang yang Direferensikan',
    推荐链接: 'Tautan Referal',
    一键分享: 'Bagikan Sekali Klik',
    合约返佣: 'Komisi Kontrak Kumulatif',
    推荐记录: 'Catatan Referal',
    返佣记录: 'Catatan Komisi',
    推荐好友: 'Rekomendasikan Teman',
    请输入账户UID: 'Silakan masukkan UID akun',
    账户UID: 'UID Akun',
    注册时间: 'Waktu Pendaftaran (UTC+8)',
    合约手续费: 'Biaya Kontrak',
    返佣活动规则说明: 'Penjelasan Aturan Aktivitas Komisi:',
    使用你的推荐链接: 'Hanya pengguna yang mendaftar menggunakan tautan referal atau kode referal Anda yang dianggap sebagai yang diundang;',
    被邀请人产生的真实交易手续费: 'Untuk biaya trading nyata yang dihasilkan oleh yang diundang, pengundang dapat menerima komisi sesuai rasio biaya trading, dikreditkan ke akun pengundang pada hari berikutnya, waktu pencatatan spesifik setelah jam 4 setiap hari;',
    用户邀请朋友无上限: 'Tidak ada batas untuk mengundang teman, hanya biaya trading kontrak dari yang diundang yang akan masuk ke komisi;',
    被邀请人只有进行合约: 'Hanya biaya trading kontrak dari yang diundang yang akan masuk ke komisi;',
    不允许任何用户通过多: 'Tidak diperbolehkan bagi pengguna mana pun untuk melakukan undangan diri melalui banyak akun, sekali terdeteksi, semua komisi akan dibatalkan, komisi biaya dari akun yang diundang juga akan dibatalkan',
    由于市场环境的改变: 'Karena perubahan kondisi pasar, adanya risiko penipuan, dll., Biking berhak untuk menyesuaikan aturan komisi kapan saja dan memiliki hak interpretasi akhir.',
    保留对活动的最终解释权: 'Jika ada pertanyaan, silakan hubungi layanan pelanggan.'
};

export { market };


// WEBPACK FOOTER //
// ./src/i18n/lang/market/ba.js